import React from 'react';
import { View, Text } from 'react-native';
import TiptapEditor from '@/components/General/inputs/QuillEditor';
import { serviceFlowStyles } from './serviceFlowStyles';

/**
 * Notes field — web uses the shared TipTap rich editor (same one used by the
 * email TextBlock). Stored HTML renders rich in the details card and PDF.
 */
const ServiceFlowNotesField = ({ value, onUpdate, disabled, testID }) => (
    <View>
        <Text style={serviceFlowStyles.fieldLabel}>Notes</Text>
        <View testID={testID} style={disabled ? { opacity: 0.6 } : null} pointerEvents={disabled ? 'none' : 'auto'}>
            <TiptapEditor
                value={value || ''}
                onChange={onUpdate}
                enableFontSize
                enableTextAlign
            />
        </View>
    </View>
);

export default ServiceFlowNotesField;
